import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";
import Order from "../../../models/Order";
import {API_URL} from "../../../utils/Constants";

interface CheckerTableProps {
    type: string
}

export const CheckerTable: React.FC<CheckerTableProps> = ({type}: CheckerTableProps) => {

    const checkerState = useAppSelector(state => state.checker);

    const accessToken = localStorage.getItem('token');

    const [totalProfit, setTotalProfit] = useState(0);
    const [averageProfit, setAverageProfit] = useState(0);
    const [totalSaleSum, setTotalSaleSum] = useState(0);
    const [totalBuySum, setTotalBuySum] = useState(0);

    const getTime = (order: Order): string => {

        const rawTime = (type === 'loadings') ? order.order_time : order.loading_time;

        if (rawTime) {
            const date = new Date(rawTime);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear().toString();
            return `${day}.${month}.${year}`;
        }

        return '';
    }

    useEffect(() => {
        let totalProfit = 0;
        let totalSaleSum = 0;
        let totalBuySum = 0;
        let orderCount = 0;

        checkerState.orders.forEach(order => {
            totalProfit += order.profit || 0;
            totalSaleSum += order.sale_sum || 0;
            totalBuySum += order.buy_sum || 0;
            orderCount += 1;

            if (order.children) {
                order.children.forEach(child => {
                    totalProfit += child.profit || 0;
                    totalSaleSum += child.sale_sum || 0;
                    totalBuySum += child.buy_sum || 0;
                    orderCount += 1;
                });
            }
        });

        setTotalProfit(totalProfit);
        setAverageProfit(totalProfit / orderCount);
        setTotalSaleSum(totalSaleSum);
        setTotalBuySum(totalBuySum);
    }, [checkerState.orders]);


    return (
        <div>
            <table className="data">
                <thead>
                <tr>
                    <th style={{width: '2%'}}>Nr</th>
                    <th style={{width: '2%'}}>Id</th>
                    <th style={{width: '6%'}}>Kuupäev</th>
                    <th style={{width: '1%', fontSize: '10px'}}>CMR</th>
                    <th style={{width: '8%'}}>Klient</th>
                    <th style={{width: '8%'}}>Hankija</th>
                    <th style={{width: '8%'}}>Teenuse liik</th>
                    <th style={{width: '15%'}}>Marsruut</th>
                    <th style={{width: '3%'}}>Ost</th>
                    <th style={{width: '3%'}}>Müük</th>
                    <th style={{width: '3%'}}>Kasum</th>
                    <th style={{width: '5%'}}>Ostuarve</th>
                    <th style={{width: '5%'}}>Müügiarve</th>
                    <th style={{width: '1%'}}>O</th>
                    <th style={{width: '1%'}}>M</th>
                    <th style={{width: '13%'}}>Kommentaar</th>
                    <th style={{width: '13%'}}>Kogus</th>
                    <th style={{width: '13%'}} className="right"></th>
                </tr>
                </thead>
                <tbody>
                {checkerState.orders.map((order, index) => {

                    const route = `${order.loading_country} (${order.loading_cities}) - ${order.unloading_country} (${order.unloading_cities})`;

                    const cellStyle = order.documents_sent ? { backgroundColor: '#e6ffe6' } : {};

                    return (
                        <React.Fragment key={index}>
                            <tr>
                                <td style={cellStyle}>{index + 1}</td>
                                <td style={cellStyle}>{order.id}</td>
                                <td style={cellStyle}>{getTime(order)}</td>
                                <td style={cellStyle}>
                                    {order.cmr === 0 && <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                    {order.cmr === 1 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                </td>
                                <td style={cellStyle}>
                                    {order?.client?.name}
                                    {order?.tax_dept == 1 &&
                                    <p style={{color: 'red', fontWeight: 'bold'}}>
                                      Maksuvõlg
                                    </p>}
                                </td>
                                <td style={cellStyle}>{order?.vendor?.name}</td>
                                <td style={cellStyle}>{order?.service?.name}</td>
                                <td style={cellStyle}>{route}</td>
                                <td style={cellStyle}>{order.buy_sum}</td>
                                <td style={cellStyle}>{order.sale_sum}</td>
                                <td style={cellStyle}>{order.profit?.toFixed(2)}</td>
                                <td style={cellStyle}>{order.buy_invoice}</td>
                                <td style={cellStyle}>{order.sale_invoice}</td>
                                <td style={cellStyle}>
                                    {order.buy_paid === 0 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                    {order.buy_paid === 1 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                </td>
                                <td style={cellStyle}>
                                    {order.sale_paid === 0 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                    {order.sale_paid === 1 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                </td>
                                <td style={cellStyle}>{order.comment}</td>
                                <td style={cellStyle}>{order.amount}</td>
                                <td style={cellStyle} className="right w150">
                                    <Link to={`/orders/new/${order.id}/parent`} style={{marginLeft: 3, marginRight: 3}}>+
                                        Alarida</Link>
                                    <span>|</span>
                                    <Link to={`/orders/${order.id}/modify`}
                                          style={{marginLeft: 3, marginRight: 3}}>Muuda</Link>
                                    <span>|</span>
                                    <Link to={`/orders/${order.id}/delete`}
                                          style={{marginLeft: 3, marginRight: 3}}>Kustuta</Link>
                                    <span>|</span>
                                    {!order.smartaccounts_id &&
                                    <Link to={`/orders/${order.id}/invoice`} style={{marginLeft: 3, marginRight: 3}}>Saada
                                      arve</Link>
                                    }
                                    {order.smartaccounts_id &&
                                    <Link to={`${API_URL}orders/${order.id}/download-invoice?token=${accessToken}`}
                                          style={{marginLeft: 3, marginRight: 3}} target={'_blank'}>Arve</Link>
                                    }
                                </td>
                            </tr>
                            {order?.children?.map((child, indexChild) => {

                                const route = `${child.loading_country} (${child.loading_cities}) - ${child.unloading_country} (${child.unloading_cities})`;

                                const cellStyle = child.documents_sent ? { backgroundColor: '#e6ffe6' } : {};

                                return (
                                    <tr>
                                        <td style={cellStyle}>{index + 1}.{indexChild + 1}</td>
                                        <td style={cellStyle}>{child.id}</td>
                                        <td style={cellStyle}>{getTime(child)}</td>
                                        <td style={cellStyle}>
                                            {child.cmr === 0 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                            {child.cmr === 1 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                        </td>
                                        <td style={cellStyle}>{child?.client?.name}</td>
                                        <td style={cellStyle}>{child?.vendor?.name}</td>
                                        <td style={cellStyle}>{child?.service?.name}</td>
                                        <td style={cellStyle}>{route}</td>
                                        <td style={cellStyle}>{child.buy_sum}</td>
                                        <td style={cellStyle}>{child.sale_sum}</td>
                                        <td style={cellStyle}>{child.profit?.toFixed(2)}</td>
                                        <td style={cellStyle}>{child.buy_invoice}</td>
                                        <td style={cellStyle}>{child.sale_invoice}</td>
                                        <td style={cellStyle}>
                                            {child.buy_paid === 0 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                            {child.buy_paid === 1 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                        </td>
                                        <td style={cellStyle}>
                                            {child.sale_paid === 0 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                            {child.sale_paid === 1 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                        </td>
                                        <td style={cellStyle}>{child.comment}</td>
                                        <td style={cellStyle}>{child.amount}</td>
                                        <td style={cellStyle} className="right w150">
                                            <Link to={`/orders/${child.id}/modify`}
                                                  style={{marginLeft: 3, marginRight: 3}}>Muuda</Link>
                                            <span>|</span>
                                            <Link to={`/orders/${child.id}/delete`}
                                                  style={{marginLeft: 3, marginRight: 3}}>Kustuta</Link>
                                            <span>|</span>
                                            {!child.smartaccounts_id &&
                                            <Link to={`/orders/${child.id}/invoice`}
                                                  style={{marginLeft: 3, marginRight: 3}}>Saada
                                              arve</Link>
                                            }
                                            {child.smartaccounts_id &&
                                            <Link
                                              to={`${API_URL}orders/${child.id}/download-invoice?token=${accessToken}`}
                                              style={{marginLeft: 3, marginRight: 3}} target={'_blank'}>Arve</Link>
                                            }
                                        </td>
                                    </tr>
                                )
                            })}
                        </React.Fragment>
                    )
                })}
                </tbody>
            </table>

            <br/>

            <div>
                Perioodi kasum kokku: <strong>{totalProfit.toFixed(2)}</strong><br/>
                Keskmine kasum: <strong>{averageProfit.toFixed(2)}</strong><br/>
                Müük kokku: <strong>{totalSaleSum.toFixed(2)}</strong><br/>
                Ost kokku: <strong>{totalBuySum.toFixed(2)}</strong>
            </div>
        </div>
    );

}